
  <button *ngIf="showToolbar"
          class="mat-icon-toggle-button" matIconButton id="screenshot-button" type="button" matTooltip="Screenshot" (click)="downloadMapCanvas()" matTooltipPosition="right">
    <mat-icon>photo_camera</mat-icon>
  </button>
